import styled, { css } from "styled-components";

export const Content = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  padding: 0 12px;
  justify-content: space-between;

  &:hover {
    background-color: var(--hv-input-foreground-hover);
  }

  &:active {
    box-shadow: var(--hv-shadow-3) !important;
    background-color: var(--hv-surface-popup);
  }
`;

export const Help = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const Info = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

export const Container = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--hv-text-normal-secondary);
  border-radius: 8px;
  border: 1px solid var(--hv-border-default);
  box-sizing: border-box;
  font-size: 14px;
  cursor: move;
  overflow: hidden;

  ${({ disabled }) =>
    !!disabled &&
    css`
      ${Info} {
        color: var(--hv-text-normal-disabled) !important;
        svg {
          &[fill="none"] {
            path {
              stroke: var(--hv-icon-normal-disabled) !important;
            }
          }
          &[stroke="none"] {
            path {
              fill: var(--hv-icon-normal-disabled) !important;
            }
          }
        }
      }
    `}
`;
